import React from "react";
import "./style.scss";
import OrderList from "../../../components/Dashboard/OrderList";

const OrderListPage = () => {
  return (
    <div className="order_list_page_wrapper">
      <OrderList />
    </div>
  );
};
export default OrderListPage;
